import { render, staticRenderFns } from "./FeeDetailReport.vue?vue&type=template&id=a6439284&scoped=true"
import script from "./FeeDetailReport.vue?vue&type=script&lang=js"
export * from "./FeeDetailReport.vue?vue&type=script&lang=js"
import style0 from "./FeeDetailReport.vue?vue&type=style&index=0&id=a6439284&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6439284",
  null
  
)

export default component.exports